const SearchIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.95643 10.8263C8.6698 10.8263 10.8694 8.6266 10.8694 5.91314C10.8694 3.19969 8.6698 1 5.95643 1C3.24307 1 1.04346 3.19969 1.04346 5.91314C1.04346 8.6266 3.24307 10.8263 5.95643 10.8263Z"
          stroke="#888888"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.76258 9.71886L12.8506 12.807"
          stroke="#888888"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SearchIcon;
